import { Injectable } from "@angular/core";
import { Http,Response, URLSearchParams } from "@angular/http";
import { HttpService } from "app/shared/http.service";
import { AppSettings } from "app/shared/app-settings";
import { Observable } from "rxjs";
import {HttpParams, HttpResponse, HttpHeaders} from "@angular/common/http";
import { tap,map, catchError } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { IPrefixMobile } from "./model/kod-mobile-prefix";
import { Options } from "selenium-webdriver";
import { environment } from "environments/environment";
import { ResultOfOperation } from "app/shared/model/result-of-operation.model";
import { IOved } from "./interface/ioved.interface";
import { Oved } from "app/shared/model/oved";
import { IOvedPeilut } from "./interface/ioved-peilut.interface";
import { OvedPeilut } from "app/shared/model/oved-peilut";
import { INofshonCharig} from "./interface/nofshon-charig.interface";
import { NofeshOvedSingleReservation } from "./interface/nofesh-oved-single-reservation";
import { IOvdimNofeshSingleReservation } from "./interface/ovdim-nofesh-single-reservation";
import { IChangeReservation } from "./interface/changeReservation";
import { IDetailsForNofeshTashlumim } from "./interface/idetails-for-nofesh-tashlumim.interface";
import { IMeshalem } from "./interface/meshalem";
import { IReservation } from "./interface/ireservation";
import { LoginService } from "app/login/login.service";
import { ConfigService } from "app/shared/config.service";
import { INofesh } from "app/nofesh/model/nofesh";
import { stringify } from "@angular/core/src/util";
import { AvailableRooms } from "./interface/available-rooms.interface";
import { IHerkevHazmana } from "app/nofshonim-chul/model/herkev-hazmana";
import { IHerkevHazmanaChangeNofshon } from "./model/herkev-hazmana-change-nofshon";
import { ChangedNofshon } from "./model/changed-nofshon";
import { IHerkevHazmanaChangeNofesh } from "./model/herkev-hazmana-change-nofesh";
import { NilvimToRemove } from "./interface/nilvim-to-remove";
import { Nilve } from "./interface/nilve";
import { NofeshNirshamimReservation } from "./interface/nofesh-nirshamim-reservation";
import { IChangeReservationMultiple } from "./interface/change-reservation-multiple";
import { NofeshNofshonNirshamim } from "./interface/nofeshNofshonNirshamim";
import { PriceType } from "./model/price-type";
import { TentativeMeurgan } from "./model/tentative-meurgan";
import { observableToBeFn } from "rxjs/internal/testing/TestScheduler";
import { AddNofeshAdmin } from "./model/add-nofesh-admin";
import { ENofeshType } from "app/shared/enums/enofesh-type.enum";
import { SpinnerService } from "app/shared/spinner/spinner.service";
import { NofshonimSummaryReport } from "./interface/reports/nofshonim-summary-report.interface";
import { NofshonNirshamimReport } from "./interface/reports/nofshon-nirshamim-report.interface";
import { NofshonMamtinimReport } from "./interface/reports/nofshon-mamtinim-report.interface";

interface IKeyValue
{
  key: number;
  value: string;
}
interface IKeyValues
{
  key: number;
  value: string;
  secondValue: string;
}

@Injectable({
    providedIn: 'root',
  })
export class AdminService { 
     
    private apiUrl: string = "";
    constructor(
        private _http: HttpService,
        private _httpClient:HttpClient,
        private _configService:ConfigService,
        private _spinnerService: SpinnerService
    )
    {
        this.apiUrl = _configService.getConfigPropertyByKey("apiUrl");
    }

    removeNilvim(nilvimToRemove: NilvimToRemove):Observable<ResultOfOperation<object>>
    {
        let url : string  = `${this.apiUrl}/api/admin/RemoveNilvimNofesh`;
        let token: any = JSON.parse(localStorage.getItem("token"));
        const headers = new HttpHeaders().set('Content-Type','application/json');
        return this._httpClient.post<ResultOfOperation<object>>(url,nilvimToRemove,{headers:headers});
    }
    addNilvimNofesh(nilvim:Nilve[]) : Observable<ResultOfOperation<object>>
    {
        let url : string  = `${this.apiUrl}/api/admin/addNilvimNofesh`;
        let token: any = JSON.parse(localStorage.getItem("token"));
        const headers = new HttpHeaders().set('Content-Type','application/json');
        return this._httpClient.post<ResultOfOperation<object>>(url,nilvim,{headers:headers});
    }

    changeNofshon(herkevHazmanaChangeNofshon:IHerkevHazmanaChangeNofshon):Observable<ResultOfOperation<object>>{
        debugger
        let url : string  = `${this.apiUrl}/api/admin/ChangeNofshon`;
        let token: any = JSON.parse(localStorage.getItem("token"));
        const headers = new HttpHeaders().set('Content-Type','application/json');
        return this._httpClient.post<ResultOfOperation<object>>(url,herkevHazmanaChangeNofshon,{headers:headers});
    }
    changeNofesh(herkevHazmanaChangeNofesh:IHerkevHazmanaChangeNofesh):Observable<ResultOfOperation<object>>{
        debugger
        let url : string  = `${this.apiUrl}/api/admin/ChangeNofesh`;
        let token: any = JSON.parse(localStorage.getItem("token"));
        const headers = new HttpHeaders().set('Content-Type','application/json');
        return this._httpClient.post<ResultOfOperation<object>>(url,herkevHazmanaChangeNofesh,{headers:headers});
    }
     
    addOved(oved:IOved):Observable<ResultOfOperation<string>>{
        let url: string = `${this.apiUrl}/api/admin/AddOved`;
        let token: any = JSON.parse(localStorage.getItem("token"));
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this._httpClient.post<ResultOfOperation<string>>(url,oved,{headers: headers});
     }

     updateOvedDetails(oved:IOved):Observable<ResultOfOperation<object>>{
         let url : string = `${this.apiUrl}/api/admin/updateOvedDetails`;
        let token :any  = JSON.parse(localStorage.getItem("token"));
        const headers  = new HttpHeaders().set('Content-Type','application/json');
        return this._httpClient.post<ResultOfOperation<Object>>(url,oved,{headers: headers});
    }
    updateOvedDetailsPeilut(oved:IOvedPeilut):Observable<ResultOfOperation<object>>{
        let url: string = `${this.apiUrl}/api/admin/updateOvedDetailsPeilut`;
        let token :any  = JSON.parse(localStorage.getItem("token"));
        const headers  = new HttpHeaders().set('Content-Type','application/json');
        return this._httpClient.post<ResultOfOperation<Object>>(url,oved,{headers: headers});
    }
    changeReservation(change: IChangeReservation) : Observable<ResultOfOperation<object>>
    {
        let url : string = `${this.apiUrl}/api/admin/changeReservation`
        const headers  = new HttpHeaders().set('Content-Type','application/json');
        return this._httpClient.post<ResultOfOperation<IChangeReservation>>(url,change,{headers:headers});
    }
    changeReservationNofeshMultiple(change: IChangeReservationMultiple) : Observable<ResultOfOperation<object>>
    {
        let url : string = `${this.apiUrl}/api/admin/changeReservationNofeshMultiple`
        const headers  = new HttpHeaders().set('Content-Type','application/json');
        return this._httpClient.post<ResultOfOperation<IChangeReservation>>(url,change,{headers:headers});
    }
    changeReservationNofshonMultiple(change: IChangeReservationMultiple) : Observable<ResultOfOperation<object>>
    {
        let url : string = `${this.apiUrl}/api/admin/changeReservationNofshonMultiple`
        const headers  = new HttpHeaders().set('Content-Type','application/json');
        return this._httpClient.post<ResultOfOperation<IChangeReservation>>(url,change,{headers:headers});
    }
    changeReservationNofshon(change: IChangeReservation) : Observable<ResultOfOperation<object>>
    {
        let url :string = `${this.apiUrl}/api/admin/changeReservationNofshon`
        const headers  = new HttpHeaders().set('Content-Type','application/json');
        return this._httpClient.post<ResultOfOperation<IChangeReservation>>(url,change,{headers:headers});
    }

    getDetailsForNofshonTashlumim(ms_zehut: number,id_nofesh:number):Observable<ResultOfOperation<IDetailsForNofeshTashlumim>>
    {
         //get nofshon payment.TODO:  -->move this to _adminService
         let url : string = `${this.apiUrl}/api/admin/getDetailsForNofshonTashlumim`
         const headers = new HttpHeaders().set('Content-type','application/json');
         const options = { 
            headers: headers,
            params: new HttpParams().set('ms_zehut', ms_zehut.toString()).set('id_nofesh',id_nofesh.toString())
        };
         return this._httpClient.get<ResultOfOperation<IDetailsForNofeshTashlumim>>(url,options);
       
    }
    getDetailsForNofeshTashlumim(ms_zehut: number,id_nofesh:number):Observable<ResultOfOperation<IDetailsForNofeshTashlumim>>
    {
         //get nofshon payment.TODO:  -->move this to _adminService
         let url : string = `${this.apiUrl}/api/admin/getDetailsForNofeshTashlumim`
         const headers = new HttpHeaders().set('Content-type','application/json');
         const options = { 
            headers: headers,
            params: new HttpParams().set('ms_zehut', ms_zehut.toString()).set('id_nofesh',id_nofesh.toString())
        };
         return this._httpClient.get<ResultOfOperation<IDetailsForNofeshTashlumim>>(url,options);
       
    }
  
    getMeshalemEmzaiTashlum(ms_zehut:number, id_nofesh:number) : Observable<ResultOfOperation<IMeshalem[]>>
    {
        let url : string = `${this.apiUrl}/api/admin/getMeshalemEmzaiTashlum`
        const headers = new HttpHeaders().set('Content-type','application/json');
        const options = { 
           headers: headers,
           params: new HttpParams().set('ms_zehut', ms_zehut.toString()).set('id_nofesh',id_nofesh.toString())
       };
       return this._httpClient.get<ResultOfOperation<IMeshalem[]>>(url,options);
    }
    getMeshalemEmzaiTashlumNofesh(ms_zehut:number, id_nofesh:number) : Observable<ResultOfOperation<IMeshalem[]>>
    {
        let url : string = `${this.apiUrl}/api/admin/getMeshalemEmzaiTashlumNofesh`
        const headers = new HttpHeaders().set('Content-type','application/json');
        const options = { 
           headers: headers,
           params: new HttpParams().set('ms_zehut', ms_zehut.toString()).set('id_nofesh',id_nofesh.toString())
       };
       return this._httpClient.get<ResultOfOperation<IMeshalem[]>>(url,options);
    }
    
    updateNofshonMeshalmim(meshalem: IMeshalem[]) :Observable<ResultOfOperation<object>[]>{
        let url : string = `${this.apiUrl}/api/admin/updateNofshonMeshalmim`;
        const headers  = new HttpHeaders().set('Content-Type','application/json');
        return this._httpClient.post<ResultOfOperation<Object>[]>(url,meshalem,{headers: headers});
    }
    updateNofeshMeshalmim(meshalem: IMeshalem[]) :Observable<ResultOfOperation<object>[]>{
        let url : string = `${this.apiUrl}/api/admin/updateNofeshMeshalmim`;
        const headers  = new HttpHeaders().set('Content-Type','application/json');
        return this._httpClient.post<ResultOfOperation<Object>[]>(url,meshalem,{headers: headers});
    }


    addOvedPeilut(oved:IOvedPeilut):Observable<ResultOfOperation<string>>{
        let url : string = `${this.apiUrl}/api/admin/addOvedPeilut`
        let token: any = JSON.parse(localStorage.getItem("token"));
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this._httpClient.post<ResultOfOperation<string>>(url,oved,{headers: headers});
     }

     updateOvedPeilut(oved:IOvedPeilut):Observable<ResultOfOperation<string>>{
        let url : string = `${this.apiUrl}/api/admin/updateOvedPeilut`
        let token: any = JSON.parse(localStorage.getItem("token"));
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this._httpClient.post<ResultOfOperation<string>>(url,oved,{headers: headers});
     }

     

    checkIsAdmin() : Observable<ResultOfOperation<object>>
     {
         let url : string = `${this.apiUrl}/api/admin/getIsAdmin`
        const headers = new HttpHeaders().set('Content-Type','application/json');
        return this._httpClient.get<ResultOfOperation<object>>(url, {headers: headers});
     }

    getOved(ms_zehut: number):Observable<ResultOfOperation<IOved>>{
        let url: string = `${this.apiUrl}/api/admin/GetOvedDeatils`
        //let params: HttpParams = new HttpParams();
        //params.set('ms_zehut', ms_zehut.toString());
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const options = { 
            params: new HttpParams().set('ms_zehut', ms_zehut.toString())
            //,
            //headers: headers 
        };
        return this._httpClient.get<ResultOfOperation<IOved>>(url,options).pipe(tap(data=>{ if(!environment.production) console.log(data)}));
        //.map((data: any) => data.json());
        
    }

    GetNofeshAllNirshamimReservation(ms_zehut_mazmin :number):Observable<ResultOfOperation<object>>
    {
        let url : string = `${this.apiUrl}/api/admin/GetNofeshAllNirshamimReservation`
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const options = { 
            headers: headers,
            params: new HttpParams().set('ms_zehut', ms_zehut_mazmin.toString())
        };
        return this._httpClient.get<ResultOfOperation<object>>(url,options);
    }
    


    
    GetNofshonimAllNirshamimReservation(ms_zehut_mazmin :number):Observable<ResultOfOperation<object>>
    {
        let url : string = `${this.apiUrl}/api/admin/GetNofshonimAllNirshamimReservation`
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const options = { 
            headers: headers,
            params: new HttpParams().set('ms_zehut', ms_zehut_mazmin.toString())
        };
        return this._httpClient.get<ResultOfOperation<object>>(url,options);
    }
    GetNofshonimAllNirshamimChangeNofshon(ms_zehut_mazmin :number):Observable<ResultOfOperation<object>>
    {
        let url : string = `${this.apiUrl}/api/admin/GetNofshonimAllNirshamimChangeNofshon`
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const options = { 
            headers: headers,
            params: new HttpParams().set('ms_zehut', ms_zehut_mazmin.toString())
        };
        return this._httpClient.get<ResultOfOperation<object>>(url,options);
    }
    GetNofeshAllNirshamimChangeNofesh(ms_zehut_mazmin :number):Observable<ResultOfOperation<object>>
    {
        let url : string = `${this.apiUrl}/api/admin/GetNofeshAllNirshamimChangeNofesh`
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const options = { 
            headers: headers,
            params: new HttpParams().set('ms_zehut', ms_zehut_mazmin.toString())
        };
        return this._httpClient.get<ResultOfOperation<object>>(url,options);
    }
    GetNofeshNofshonimAllNirshamimForOved(ms_zehut_mazmin :number):Observable<ResultOfOperation<object>>
    {
        let url : string = `${this.apiUrl}/api/admin/GetNofeshNofshonimAllNirshamimForOved`
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const options = { 
            headers: headers,
            params: new HttpParams().set('ms_zehut', ms_zehut_mazmin.toString())
        };
        return this._httpClient.get<ResultOfOperation<object>>(url,options);
    }
    GetCurrentNofeshMisparChadarim(ms_zehut_mazmin:number,id_nofesh: number):Observable<ResultOfOperation<number>>{
        let url : string = `${this.apiUrl}/api/admin/GetCurrentNofeshMisparChadarim`
        const headers  = new HttpHeaders().set('Content-Type','application/json');
        const options = {
            headers: headers,
            params: new HttpParams().set('ms_zehut_mazmin',ms_zehut_mazmin.toString()).set('id_nofesh',id_nofesh.toString())
        }
        return this._httpClient.get<ResultOfOperation<number>>(url,options).pipe(tap(data => {console.log(data)}))
    }

    GetCurrentHerkevHazmana(ms_zehut_mazmin:number,id_nofesh: number):Observable<ResultOfOperation<IHerkevHazmana>>
    {
        let url : string = `${this.apiUrl}/api/admin/GetCurrentHerkevHazmana`;
        const headers  = new HttpHeaders().set('Content-Type','application/json');
        const options = {
            headers: headers,
            params: new HttpParams().set('ms_zehut_mazmin',ms_zehut_mazmin.toString()).set('id_nofesh',id_nofesh.toString())
        }
        return this._httpClient.get<ResultOfOperation<IHerkevHazmana>>(url,options).pipe(tap(data => {console.log(data)}))
    }

    getNofeshTitles(reservations: IReservation[]) : IKeyValue[]
    {
        let nofeshTitles : IKeyValue[] = [];
        nofeshTitles = [
            { key: 0, value: "בחר" }
          ];
        for(let reservation of reservations)
        {
            // Index 0 because we take the data from the first nirsham
            nofeshTitles.push({key: reservation.nirshamim[0].id_nofesh, value:reservation.nirshamim[0].nofesh_title});
        }
        return nofeshTitles;

        // reservations.forEach(reservation => { 
        //     nofeshTitles.push({key: reservation.nirshamim[0].id_nofesh, value:reservation.nirshamim[0].nofesh_title});
        //   });
        //use for because it's sync and not Async. we need the loop to finish first before rtuerning it. 

    }
    formatTime(time, prefix = "") {
        return typeof time == "object" ? prefix + time.toLocaleDateString() : "";
    }

    getAllReservationsNofesh(id_nofesh:number) : Observable<ResultOfOperation<NofeshNofshonNirshamim[]>>
    {
        let url: string = `${this.apiUrl}/api/admin/getAllReservationsNofesh`;
        const headers =new HttpHeaders().set('Content-Type','application/json');
        const options = {
            headers:headers,
            params: new HttpParams().set('id_nofesh',id_nofesh.toString())
        };
        return this._httpClient.get<ResultOfOperation<NofeshNofshonNirshamim[]>>(url,options);

    }
    getAllReservationsNofshon(id_nofesh:number) : Observable<ResultOfOperation<NofeshNofshonNirshamim[]>>
    {
        let url: string = `${this.apiUrl}/api/admin/getAllReservationsNofshon`;
        const headers =new HttpHeaders().set('Content-Type','application/json');
        const options = {
            headers:headers,
            params: new HttpParams().set('id_nofesh',id_nofesh.toString())
        };
        return this._httpClient.get<ResultOfOperation<NofeshNofshonNirshamim[]>>(url,options);

    }
    getAllNofshonimTitles(nofshonim: INofesh[]) : IKeyValues[]
    {
        let nofeshTitles : IKeyValues[] = [];
        nofeshTitles = [
            { key: 0, value: "בחר", secondValue: "" }
          ];
        
        //2.filter the id_nofesh from nofshonim
        nofshonim = nofshonim.filter(nofshonim=> (nofshonim.nofeshType== ENofeshType.NofeshChul || nofshonim.nofeshType == ENofeshType.NofeshPnim || nofshonim.nofeshType == ENofeshType.MeurganimChul));
        
        for(let reservation of nofshonim)
        {
            let fromDate = reservation.fromTkufatNofesh.toString();
             let fromDateDay = fromDate.substring(8,10)
             let fromDateMonth = fromDate.substring(5,7)
             let fromDateYear = fromDate.substring(0,4)
             fromDate = `${fromDateDay}/${fromDateMonth}/${fromDateYear}`;
             let toDate = reservation.toTkufatNofesh.toString();
             let toDateDay = toDate.substring(8,10)
             let toDateMonth = toDate.substring(5,7)
             let toDateYear = toDate.substring(0,4)
             toDate = `${toDateDay}/${toDateMonth}/${toDateYear}`;
            nofeshTitles.push({key: reservation.id_nofesh, value:reservation.nofeshTitle,secondValue:fromDate+"-"+toDate});
        }
        return nofeshTitles;
    }
    getDataForNofeshTentative(id_nofesh:Number): Observable<ResultOfOperation<TentativeMeurgan>>
    {
        let url: string = `${this.apiUrl}/api/admin/getDataForNofeshTentative`;
        const headers =new HttpHeaders().set('Content-Type','application/json');
        const options = {
            headers:headers,
            params: new HttpParams().set('id_nofesh',id_nofesh.toString())
        };
        return this._httpClient.get<ResultOfOperation<TentativeMeurgan>>(url,options);
    }
    getAllNofeshTitles(nofshonim: INofesh[]) : IKeyValues[]
    {
        let nofeshTitles : IKeyValues[] = [];
        nofeshTitles = [
            { key: 0, value: "בחר", secondValue: "" }
          ];

        //2.filter the id_nofesh from nofshonim
        nofshonim.filter(x=>x.nofeshType = 4);

        for(let reservation of nofshonim)
        {
            let fromDate = reservation.fromTkufatNofesh.toString();
             let fromDateDay = fromDate.substring(8,10)
             let fromDateMonth = fromDate.substring(5,7)
             let fromDateYear = fromDate.substring(0,4)
             fromDate = `${fromDateDay}/${fromDateMonth}/${fromDateYear}`;
             let toDate = reservation.toTkufatNofesh.toString();
             let toDateDay = toDate.substring(8,10)
             let toDateMonth = toDate.substring(5,7)
             let toDateYear = toDate.substring(0,4)
             toDate = `${toDateDay}/${toDateMonth}/${toDateYear}`;
            nofeshTitles.push({key: reservation.id_nofesh, value:reservation.nofeshTitle,secondValue:fromDate+"-"+toDate});
        }
        return nofeshTitles;
    }
    GetAvailableRoomsAndMamtinimForSelectedNofesh(id_nofesh:number):Observable<ResultOfOperation<AvailableRooms>>
    {
        let url: string = `${this.apiUrl}/api/admin/GetAvailableRoomsAndMamtinimForSelectedNofesh`;
        const headers =new HttpHeaders().set('Content-Type','application/json');
        const options = {
            headers:headers,
            params: new HttpParams().set('id_nofesh',id_nofesh.toString())
        };
        return this._httpClient.get<ResultOfOperation<AvailableRooms>>(url,options);
    }

        getOvedPeilut(ms_zehut: number):Observable<ResultOfOperation<IOvedPeilut>>{
            let url : string = `${this.apiUrl}/api/admin/GetOvedDetailsPeilut`
        //let params: HttpParams = new HttpParams();
        //params.set('ms_zehut', ms_zehut.toString());
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const options = { 
            headers: headers,
            params: new HttpParams().set('ms_zehut', ms_zehut.toString())
            //,
            //headers: headers 
        };
        return this._httpClient.get<ResultOfOperation<IOvedPeilut>>(url,options).pipe(tap(data=>{ if(!environment.production) console.log(data)}));
        //.map((data: any) => data.json());
        
    }
    getNofshonimCharigim():Observable<ResultOfOperation<INofshonCharig[]>>
    {
        let url : string  = `${this.apiUrl}/api/admin/getNofshonimCharigim`
        const headers  = new HttpHeaders().set('Content-Type','application/json');
        return this._httpClient.get<ResultOfOperation<INofshonCharig[]>>(url,{headers:headers}).pipe(tap(data=>{console.log(data.data)}))
    }

    GetOvedNofeshSingleReservation(ms_zehut_mazmin:string):Observable<ResultOfOperation<NofeshOvedSingleReservation>>{
        let url : string = `${this.apiUrl}/api/admin/GetOvedNofeshSingleReservation`
        const headers  = new HttpHeaders().set('Content-Type','application/json');
        const options = {
            headers: headers,
            params: new HttpParams().set('ms_zehut_mazmin',ms_zehut_mazmin)
        }
        return this._httpClient.get<ResultOfOperation<NofeshOvedSingleReservation>>(url,options).pipe(tap(data => {console.log(data)}))
    }
    nofeshUniteSingles(nofeshOvdimSingles: IOvdimNofeshSingleReservation) : Observable<ResultOfOperation<object>>
    {
        let url : string = `${this.apiUrl}/api/admin/nofeshUniteSingles`
        const headers = new HttpHeaders().set('Content-Type','application/json');
        return this._httpClient.post<ResultOfOperation<IOvdimNofeshSingleReservation>>(url,nofeshOvdimSingles,{headers:headers})
    }

    IsOvedExists(ms_zehut: number):Observable<any>{
        let url : string  = `${this.apiUrl}/api/admin/IsOvedExists`
        //let params: HttpParams = new HttpParams();
        //params.set('ms_zehut', ms_zehut.toString());
        let token: any = JSON.parse(localStorage.getItem("token"));
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const options = 
       { params: new HttpParams().set('ms_zehut', ms_zehut.toString()),headers:headers };
        return this._httpClient.get<any>(url,options).pipe(tap(data=>console.log(data)));
        //.map((data: any) => data.json());
        
    }
    IsOvedExistsPeilut(ms_zehut: number):Observable<any>{
        let url : string = `${this.apiUrl}/api/admin/isOvedExistsPeilut`
        //let params: HttpParams = new HttpParams();
        //params.set('ms_zehut', ms_zehut.toString());
        let token: any = JSON.parse(localStorage.getItem("token"));
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const options = 
       { params: new HttpParams().set('ms_zehut', ms_zehut.toString()),headers:headers };
        return this._httpClient.get<any>(url,options).pipe(tap(data=>console.log(data)));
        //.map((data: any) => data.json());
        
    }

    deleteOved(Oved:Oved) : Observable<ResultOfOperation<object>>
   {
       let url : string = `${this.apiUrl}/api/admin/deleteOved`
        //let token :any  = JSON.parse(localStorage.getItem("token"));
        const headers  = new HttpHeaders().set('Content-Type','application/json');
        return this._httpClient.post<ResultOfOperation<Object>>(url, Oved, { headers: headers }).pipe(tap(data=> {console.log("data isSuccess: - deleted:",data.isSuccess)}));
    }
    
    deleteOvedPeilut(Oved:OvedPeilut) : Observable<ResultOfOperation<object>>
   {
       let url : string = `${this.apiUrl}/api/admin/deleteOvedPeilut`
        //let token :any  = JSON.parse(localStorage.getItem("token"));
        const headers  = new HttpHeaders().set('Content-Type','application/json');
        return this._httpClient.post<ResultOfOperation<Object>>(url, Oved, { headers: headers }).pipe(tap(data=> {console.log("data isSuccess: - deleted:",data.isSuccess)}));
    }
    
    deleteNofshonCharig(nofshonCharig : INofshonCharig) : Observable<ResultOfOperation<object>>
    {
        let url : string = `${this.apiUrl}/api/admin/deleteNofshonCharig`
        const headers  = new HttpHeaders().set('Content-Type','application/json');
        return this._httpClient.post<ResultOfOperation<Object>>(url,nofshonCharig);
    }

    getMobilePrefixes():Observable<any>
    {
        let url : string = `${this.apiUrl}/api/admin/GetMobilePrefixes`
        //let token: any = JSON.parse(localStorage.getItem("token"));
        const headers = new HttpHeaders().set('Content-Type', 'application/json')//.set('Authorization','Bearer ' + token.token);
        return this._httpClient.get<any>(url,{headers: headers})
    }
    getPriceTypeMeurgan():Observable<ResultOfOperation<PriceType[]>>
    {
        let url : string = `${this.apiUrl}/api/admin/getPriceTypeMeurgan`
        //let token: any = JSON.parse(localStorage.getItem("token"));
        const headers = new HttpHeaders().set('Content-Type', 'application/json')//.set('Authorization','Bearer ' + token.token);
        return this._httpClient.get<ResultOfOperation<PriceType[]>>(url,{headers: headers})
    }
    addNewNofesh(nofesh:AddNofeshAdmin):Observable<ResultOfOperation<object>>
    {
        let url : string = `${this.apiUrl}/api/admin/addNewNofesh`
        const headers  = new HttpHeaders().set('Content-Type','application/json');
        return this._httpClient.post<ResultOfOperation<Object>>(url,nofesh);
    }

    getReportIssueTime(): string
    {
        const now = new Date();
        const hour = now.getHours() < 10 ? `0${now.getHours()}` : now.getHours();
        const min = now.getMinutes() < 10 ? `0${now.getMinutes()}` : now.getMinutes();
        const sec = now.getSeconds() < 10 ? `0${now.getSeconds()}` : now.getSeconds();
        const result = `${hour}:${min}:${sec}`;
        return result;
    }

    getNofshonimSummaryReport(): Observable<ResultOfOperation<NofshonimSummaryReport[]>>
    {
        this._spinnerService.showSpinner();
        return this._httpClient.get<ResultOfOperation<NofshonimSummaryReport[]>>(`${this.apiUrl}/api/Admin/GetNofshonimSummaryReport`)
            .pipe(
                tap(response => {
                    if(!environment.production)
                    {
                        console.log(response);
                    }

                    this._spinnerService.hideSpinner();
                },
                error => {
                    this._spinnerService.hideSpinner();
                })
            );
    }

    getNofshonNirshamimReport(idNofesh: string): Observable<NofshonNirshamimReport[]>
    {
        this._spinnerService.showSpinner();
        const httpParams = new HttpParams().set("idNofesh", idNofesh);
        return this._httpClient.get<NofshonNirshamimReport[]>(`${this.apiUrl}/api/Admin/GetNofshonNirshamimReport`, { params: httpParams })
            .pipe(tap(
                response => {
                    this._spinnerService.hideSpinner();
                },
                error => {
                    this._spinnerService.hideSpinner();
                }
            ));
    }

    getNofshonMamtinimReport(idNofesh: string): Observable<NofshonMamtinimReport[]>
    {
        this._spinnerService.showSpinner();
        const httpParams = new HttpParams().set("idNofesh", idNofesh);
        return this._httpClient.get<NofshonMamtinimReport[]>(`${this.apiUrl}/api/Admin/GetNofshonMamtinimReport`, { params: httpParams })
            .pipe(tap(
                response => {
                    if(!environment.production)
                    {
                        console.log(response);
                    }
                    
                    this._spinnerService.hideSpinner();
                },
                error => {
                    this._spinnerService.hideSpinner();
                }
            ));
    }
}